var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from "react";
import { usePortal } from "../hooks/usePortal";
import { useWindow } from "../hooks/useWindow";
export function Window(_a) {
    var { children } = _a, windowProps = __rest(_a, ["children"]);
    const portalWindow = useWindow(windowProps);
    const portal = usePortal({
        source: children,
        target: portalWindow === null || portalWindow === void 0 ? void 0 : portalWindow.document.body,
    });
    return React.createElement(React.Fragment, null, portal);
}
